export class Seat {
  readonly id: string;
  readonly type: string;
  readonly row: number;
  readonly rowLabel: string;
  readonly seat: number;
  readonly columnLabel: string;
  readonly section: string;

  constructor(
    id: string,
    type: string,
    row: number,
    rowLabel: string,
    seat: number,
    columnLabel: string,
    section: string
  ) {
    this.id = id;
    this.type = type;
    this.row = row;
    this.rowLabel = rowLabel;
    this.seat = seat;
    this.columnLabel = columnLabel;
    this.section = section;
  }
}

export interface SeatType {
  id: string;
  name: string;
  colorDark: string;
  colorLight: string;
  isDefault: boolean;
  calculatedTakenColorDark?: string;
  calculatedTakenColorLight?: string;
}
